import { render, staticRenderFns } from "./PassWordManage.vue?vue&type=template&id=77036014&scoped=true"
import script from "./PassWordManage.vue?vue&type=script&lang=js"
export * from "./PassWordManage.vue?vue&type=script&lang=js"
import style0 from "./PassWordManage.vue?vue&type=style&index=0&id=77036014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77036014",
  null
  
)

export default component.exports